
export function Loading({ display }) {
    if (!display) {
        return null;
    }

    return (<div className="has-loading" style={{ marginTop: '10em' }}></div>);
}
